export const SUPPORTIVE_TICKETS_WORKFLOW_KEYS = {
	ALL: 'ALL',
	SENT: 'SENT',
	IN_PROGRESS: 'IN_PROGRESS',
	DONE: 'DONE',
};

export const SUPPORTIVE_TICKETS_WORKFLOW_LABELS = {
	ALL: 'همه',
	SENT: 'ارسال شده',
	IN_PROGRESS: 'در حال بررسی',
	DONE: 'بسته شده',
};

export const SUPPORTIVE_TICKETS_WORKFLOW_STATES = {
	ALL: [],
	SENT: [],
	IN_PROGRESS: [
		'open_states',
		'in_progress',
		'merchant_support',
		'merchant',
		'support_manager',
		'support_agent',
		'supervisor',
		'sales_manager',
		'sales_agent',
		'content_manager',
		'content_agent',
		'boosting_sales_agent',
		'boosting_supervisor',
		'boosting_manager',
		'cashback_management',
		'merchant_support',
		'merchant',
		'cashback',
		'accountant',
		'marketing',
		'tech',
		'product',
		'hr_agent',
		'office',
		'admin',
	],
	DONE: ['done', 'canceled', 'closed_states'],
};
